import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import EmailLists from './EmailLists'

import * as S from './styles'

import type {
  RelatedUser,
  RelatedUsersList
} from '@/types/components/Modal/Templates/ShareCollection'

interface ManagementViewProps {
  onClose: () => void
  onUnshare: (user: RelatedUser) => void
  accessList: RelatedUsersList
}

export default function ManagementView({
  onClose,
  onUnshare,
  accessList
}: ManagementViewProps) {
  const { t } = useTranslation()

  useEffect(() => {
    if (!accessList.length) {
      onClose()
    }
  }, [accessList])

  return (
    <S.ManagementViewContainer>
      <EmailLists
        lists={[
          {
            title: t('subtitles.emailsWithAccess'),
            key: 'users-with-access',
            users: accessList
          }
        ]}
        onRemove={onUnshare}
      />

      <S.SharedListButtons>
        <button type="submit" onClick={onClose} id="btn_add_new_emails">
          {t('buttons.addNewEmails')}
        </button>
      </S.SharedListButtons>
    </S.ManagementViewContainer>
  )
}
